<template>
  <v-container-restricted
    style="max-width: 1200px"
    class="text-center d-flex flex-column align-center"
    :class="Spacings.homePageSectionPadding"
  >
    <underlined-heading :text="$t('taHome.latestNews')"></underlined-heading>

    <v-container-np :class="Spacings.homePageHeadingMargin">
      <v-row
        no-gutters
        justify="space-between"
        class="text-center text-sm-left"
      >
        <v-col cols="12" sm="7">
          <SlideOnIntersectContainer direction="left">
            <v-container-np>
              <Image
                :with-bg="true"
                class="rounded-xl"
                :src="posts[0].img"
                :full-width="true"
                :cover="true"
                aspect-ratio="4/2"
              ></Image>
              <NuxtLink
                class="text-decoration-none text-black"
                :to="posts[0].link"
                external
                target="_blank"
              >
                <p
                  class="text-h6 text-sm-h5 text-md-h4 my-2 text-decoration-underline limit-to-2-lines-gh"
                >
                  {{ posts[0].title }}
                </p>
              </NuxtLink>
              <p class="text-subtitle-1 limit-to-8-lines">
                {{ posts[0].subtitle }}
              </p>
            </v-container-np>
          </SlideOnIntersectContainer>
        </v-col>
        <v-col
          cols="12"
          sm="5"
          align="center"
          class="pl-sm-5 pl-md-16 text-center text-sm-left"
        >
          <v-row no-gutters>
            <v-col class="my-10 my-sm-0 mb-sm-5" cols="12">
              <SlideOnIntersectContainer direction="top">
                <v-container-np>
                  <Image
                    :with-bg="true"
                    class="rounded-xl"
                    :src="posts[1].img"
                    :full-width="true"
                    :cover="true"
                    aspect-ratio="4/2"
                  ></Image>
                  <NuxtLink
                    class="text-decoration-none text-black"
                    :to="posts[1].link"
                    external
                    target="_blank"
                  >
                    <p
                      class="text-h6 my-2 text-decoration-underline limit-to-1-lines-h6"
                    >
                      {{ posts[1].title }}
                    </p>
                  </NuxtLink>
                  <p class="text-subtitle-1 limit-to-2-lines">
                    {{ posts[1].subtitle }}
                  </p>
                </v-container-np>
              </SlideOnIntersectContainer>
            </v-col>
            <v-col cols="12">
              <SlideOnIntersectContainer direction="bottom">
                <v-container-np>
                  <Image
                    :with-bg="true"
                    class="rounded-xl"
                    :src="posts[2].img"
                    :full-width="true"
                    :cover="true"
                    aspect-ratio="4/2"
                  ></Image>
                  <NuxtLink
                    class="text-decoration-none text-black"
                    :to="posts[2].link"
                    external
                    target="_blank"
                  >
                    <p
                      class="text-h6 my-2 text-decoration-underline limit-to-1-lines-h6"
                    >
                      {{ posts[2].title }}
                    </p>
                  </NuxtLink>
                  <p class="text-subtitle-1 limit-to-2-lines">
                    {{ posts[2].subtitle }}
                  </p>
                </v-container-np>
              </SlideOnIntersectContainer>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container-np>
  </v-container-restricted>
</template>
<script setup lang="ts">
import { Spacings } from "~/core/constants/vuetify-class-constants/spacings";
import SlideOnIntersectContainer from "../common/animation/SlideOnIntersectContainer.vue";

const posts: { title: string; img: string; subtitle: string; link: string }[] =
  [
    {
      link: "https://www.artificial-intelligence.blog/ai-news/the-enigma-of-enforcing-gdpr-on-llms",
      title: "The Enigma of Enforcing GDPR on LLMs",
      img: "https://images.squarespace-cdn.com/content/v1/62ec2bc76a27db7b37a2b32f/3cf66c8e-6d0a-4cff-b4f3-5076093ff773/gdpr-vs-privacy-vs-llm.jpg?format=500w",
      subtitle:
        "In the digital age, data privacy is a paramount concern, and regulations like the General Data Protection Regulation (GDPR) aim to protect individuals' personal data. However, the advent of large language models (LLMs) such as GPT-4, BERT, and their kin pose significant challenges to the enforcement of GDPR. These models, which generate text by predicting the next token based on patterns in vast amounts of training data, inherently complicate the regulatory landscape. Here’s why enforcing GDPR on LLMs is practically impossible.",
    },
    {
      link: "https://www.artificial-intelligence.blog/ai-news/gpt-4o-tells-jokes-about-ai",
      title: "GPT-4o Tells Jokes about AI",
      img: "https://images.squarespace-cdn.com/content/v1/62ec2bc76a27db7b37a2b32f/074c29ee-7084-45ab-a570-01736cd1df2e/bad-ai-jokes.jpg?format=500w",
      subtitle:
        "We critique the GPT-4o model for its lack of creativity and repetitiveness in generating AI-related jokes, noting that while the jokes are safe and grammatically correct.",
    },
    {
      link: "https://www.artificial-intelligence.blog/ai-news/talking-with-gpt-4o-in-a-fake-language",
      title: "Talking with GPT-4o in a Fake Language",
      img: "https://images.squarespace-cdn.com/content/v1/62ec2bc76a27db7b37a2b32f/043cf9dd-e352-445a-8584-614f6c04dbf3/speaking-to-gpt-4o-in-fake-language.jpg?format=500w",
      subtitle:
        "The article explores an experiment where GPT-4o attempts to understand and communicate in a completely made-up language with similarities to a German dialect,",
    },
  ];
</script>
<style scoped>
.limit-to-1-lines-h6 {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  line-clamp: 1;
  -webkit-box-orient: vertical;
  line-height: 30px;
  overflow: hidden;
  max-height: calc(1 * 30px);
}

.limit-to-2-lines {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  line-height: 22px;
  overflow: hidden;
  max-height: calc(2 * 22px);
}

.limit-to-2-lines-gh {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
}

.limit-to-8-lines {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 8;
  line-clamp: 8;
  -webkit-box-orient: vertical;
  line-height: 22px;
  overflow: hidden;
  max-height: calc(8 * 22px);
}

@media screen and (max-width: 599px) {
  .limit-to-8-lines {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;
    line-height: 22px;
    overflow: hidden;
    max-height: calc(2 * 22px);
  }
}
</style>
